import { useId } from 'react';
import { RoadmapBucket } from './unitFocusBuckets';

interface Props {
  buckets: RoadmapBucket[];
  selectedRoadmapId: string;
  onSelect: (id: string) => void;
}

export const UnitFocusRoadmapSegment = ({ buckets, selectedRoadmapId, onSelect }: Props): JSX.Element => {
  const groupLabelId = useId();

  return (
    <section className="tw-relative tw-h-fit tw-w-full">
      <h2 id={groupLabelId} className="tw-sr-only">
        Roadmap toggle group
      </h2>
      <div
        role="radiogroup"
        aria-labelledby={groupLabelId}
        className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-1 tw-rounded-full tw-border-2 tw-border-solid tw-border-neutral-100 tw-bg-neutral-50 tw-p-2"
      >
        {buckets.map(item => {
          const isSelected = item.id === selectedRoadmapId;

          return (
            <button
              key={item.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              onClick={() => onSelect(item.id)}
              className={`tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-full tw-border-2 tw-border-solid tw-px-2 tw-py-1 ${
                isSelected
                  ? 'tw-border-neutral-100 tw-bg-neutral-0 tw-shadow-[0px_0px_10px_0px_rgba(132,123,111,0.1)]'
                  : 'tw-border-transparent tw-bg-neutral-50'
              }`}
            >
              <span
                className={`tw-whitespace-nowrap tw-font-atkinson tw-text-sm tw-font-bold ${
                  isSelected ? 'tw-text-indigo-600' : 'tw-text-neutral-700'
                }`}
              >
                {item.name}
              </span>
              <span
                className={`tw-font-atkinson tw-text-xs tw-font-bold ${
                  isSelected ? 'tw-text-indigo-600' : 'tw-text-neutral-700'
                }`}
              >
                ({item.studentIds.length})
              </span>
            </button>
          );
        })}

        <div className="tw-flex tw-h-5 tw-flex-1 tw-items-center tw-justify-end tw-pr-2">
          <span className="tw-whitespace-nowrap tw-font-atkinson tw-text-xs tw-italic tw-text-neutral-600">
            {buckets.length} Roadmap{buckets.length === 1 ? '' : 's'}
          </span>
        </div>
      </div>
    </section>
  );
};
